/** The soft moving colour field every glass surface sits on. */
export function Aurora() {
  return (
    <div className="aurora" aria-hidden>
      <i /><i /><i /><i />
    </div>
  );
}
